import { PaginationRequest } from './api';
import { Map } from './universal';

export interface Comic {
	comicUUID?: string;
	imageURL: string;
	title: string;
	description: string;
	author: string;
	status: ComicStatus;
	type: ComicType;
	genres: string[];
	note: string;
	chapter: Map<Chapter>;
	isFavorite?: boolean;
	createdAt?: Date;
	updatedAt?: Date;
}

export interface Chapter {
	link: string;
	documentUUID?: string;
	content?: string;
	createdAt?: Date;
}

export const genres: string[] = [
	'Action',
	'Adult',
	'Drama',
	'Fantasy',
	'Mature',
	'Romance',
	'Harem',
	'Sport',
	'Sci-fi',
	'Comedy',
	'Slice of Life',
	'Adventure',
	'Yaoi',
	'Seinen',
	'Trap',
	'Gender Bender',
	'Second Life',
	'Isekai',
	'School Life',
	'Mystery',
	'Horror',
	'Shounen',
	'Shoujo',
	'Yuri',
	'Gourmet',
	'Reincanate'
].sort();

export enum ComicType {
	Manga = 'manga',
	Manhwa = 'manhwa',
	Novel = 'novel'
}

export enum ComicStatus {
	Ongoing = 'ongoing',
	Complete = 'complete',
	Oneshot = 'oneshot'
}

export interface ComicPaginationRequest extends PaginationRequest {
	search?: string;
	type: ComicType;
	status?: ComicStatus;
}
